import {useLayoutEffect, useRef} from "react";
import {Image} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import backIcon from './../../asset/icons/backIcon.svg'

const BackButton = ({specialClass, onclickFunction}) => {
  const btnBackRef = useRef(null)
  const {i18n: {dir, language}} = useTranslation()

  useLayoutEffect(() => {
    const btn = btnBackRef.current
    if (dir(language) === 'ltr') {
      btn.style.transform = 'rotate(180deg)'
    } else {
      btn.style.removeProperty('transform')
    }
  }, [dir, language])

  return (
    <div ref={btnBackRef} className={`back_btn ${specialClass}`} onClick={onclickFunction}>
      <Image src={backIcon} className="image"/>
    </div>
  );
};

export default BackButton;
